__turbopack_context__.v({
  "container": "Captcha-module__yhHwSG__container",
  "invertedColors": "Captcha-module__yhHwSG__invertedColors",
});
